export const CHECK_LOAN_START = 'CHECK_LOAN_START';
export const CHECK_LOAN_SUCCESS = 'CHECK_LOAN_SUCCESS';
export const CHECK_LOAN_ERROR = 'CHECK_LOAN_ERROR';
export const CHECK_LOAN_END = 'CHECK_LOAN_END';
export const CLEAR_CHECK_ELIGIBILITY = 'CLEAR_CHECK_ELIGIBILITY';
